module.exports = __webpack_public_path__ + "img/button_default_03.b7ada866.png";